<!-- 售后服务顶部导航 -->
<template>
  <van-nav-bar
    :title="title"
    :border="false"
    left-arrow
    placeholder
    z-index="9"
    fixed
    @click-left="goBack"
    class="base-head"
  >
    <template #left>
      <van-icon name="arrow-left" class="base-head__goback" />
    </template>
  </van-nav-bar>
</template>

<script>
import { Icon, NavBar } from 'vant'
import wx from 'weixin-js-sdk'
import NativeAPI from '_u/nativeAPI'
export default {
  components: {
    [Icon.name]: Icon,
    [NavBar.name]: NavBar
  },
  data() {
    return {
      propsTitle: undefined,
      souce: this.$store.state.sev.souce,
      entrance: this.$store.state.sev.entrance
    }
  },
  computed: {
    title() {
      if (this.propsTitle) return this.propsTitle
      return this.$route.meta.title ? `${this.$route.meta.title}` : '售后服务'
    },
    showClose() {
      // 当前页面名称和保存的入口页名称一致
      const theSame = this.$route.name === this.entrance
      // souce:1->APP,2->服务号,3->小程序,4->商城H5,5->评价页面,6->收费标准
      const souce = [1, 3, 5, 6].includes(this.souce)
      return theSame && souce
    }
  },
  created() {
    // 更改导航栏title
    this.$bus.$on('navbar-title', title => {
      this.propsTitle = title
    })
  },
  methods: {
    async goBack() {
      console.log('showClose', this.showClose)
      console.log('name', this.$route.name)
      if (this.showClose || this.$route.name === 'errorpage') {
        switch (this.souce) {
          case 1:
            // 调用App关闭方法
            NativeAPI.callNativeApi('toAppClosePage')
            break
          case 3:
            // 调用小程序Webview Api
            wx.miniProgram.navigateBack()
            break
          case 5:
            // 入口只有扫码或者打开链接
            // 调用微信关闭浏览器功能
            if (this.$bus.isWeixin) wx.closeWindow()
            else window.close()
            break
          case 6:
            // 调用App关闭方法
            NativeAPI.callNativeApi('toAppClosePage')
            break
        }
      } else {
        this.$router.go(-1)
      }
      this.propsTitle = undefined
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.van-nav-bar--fixed {
  left: 50% !important;
  transform: translateX(-50%) !important;
  max-width: 750px !important;
  position: fixed;
  top: 0;
  width: 100%;
}
/deep/.van-nav-bar__title {
  font-weight: bold;
  line-height: 19px;
}
/deep/.van-nav-bar__left {
  padding: 0 10px;
  .van-icon {
    font-size: 22px;
  }
}
</style>
